import styled from 'styled-components';

export const Block = styled.div`
  float: right;
  position: relative;
`;
export const Label = styled.span`
  position: absolute;
  right: 0;
  background-color: rgba(220, 220, 220, 0.8);
  color: #666;
  font-size: 11px;
  padding: 0px 3px;
`;
